import TaskManagementBase from './TaskManagementBase';

export default function Merchandise({ user }) {
  return (
    <TaskManagementBase
      user={user}
      moduleName="Merchandise"
      moduleTitle="Merchandise"
      moduleDescription="Merchandise planning, product development, and vendor coordination"
    />
  );
}
